import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, CardContent, Card, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import AccordionFaq from './accordionFaq';
import DialogContact from './dialogContact';
import styleGlobal from '../../Global.module.css';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(2),
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  instagram: {
    width: '100%',
    height: 500,
    border: 0,
    overflow: 'hidden',
  },
  reactplayer: {
    position: 'relative',
    top: 0,
    left: 0,
  },
  playerwrapper: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: 25,
    height: 0,
  },
}));

function HtmlTooltip(props) {
  return (
    <Tooltip
      {...props}
      arrow
      placement="right"
      title={props.title}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#FFFFFF',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 400,
            fontSize: '0.875rem',
            border: '1px solid #4bf717',
          },
        },
      }}
    />
  );
}

export default function Instructions() {
  const classes = useStyles();

  return (
    <header className={styleGlobal.headerGlobal}>
      <Card style={{ padding: '3rem', borderRadius: '20px' }}>
        <h2>
          Perguntas Frequentes{' '}
          <HtmlTooltip
            title={
              <>
                As perguntas frequentes são compiladas de dúvidas comuns entre
                os usuários do sistema. Você pode entrar em contato via Whatsapp
                e tirar mais dúvidas com o nosso suporte técnico.
              </>
            }
          >
            <InfoIcon color="primary" fontSize="inherit" />
          </HtmlTooltip>
        </h2>

        <CardContent style={{ padding: 0 }}>
          <AccordionFaq />
        </CardContent>

        <Grid container justifyContent="center" sx={{ marginTop: 3 }}>
          <DialogContact />
        </Grid>
      </Card>
    </header>
  );
}
